/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Umbrella Page Survey Api
 * OpenAPI spec version: 1.0
 */

import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
	BodyType,
	ErrorType,
} from "../../../../../_packages/umbrella/lib/orval/custom-instance.ts";

import { customInstance } from "../../../../../_packages/umbrella/lib/orval/custom-instance.ts";
import type {
	CreatePageSurveyRatedQuestionRequest,
	CreatePageSurveyRequest,
	PageSurveyRatedQuestionResponse,
	PageSurveyResponse,
	UpdatePageSurveyRatedQuestionRequest,
	UpdatePageSurveyRequest,
} from "../../models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
	query: T,
	queryKey: K,
): T & { queryKey: K } => {
	const result = { queryKey } as T & { queryKey: K };
	for (const key of Object.keys(query)) {
		// The explicit queryKey always wins, matching the previous
		// `{ ...query, queryKey }` spread where it was set last.
		if (key === "queryKey") continue;
		Object.defineProperty(result, key, {
			enumerable: true,
			configurable: true,
			get: () => (query as Record<string, unknown>)[key],
		});
	}
	return result;
};

export const postUmbracoApiV1UmbrellaPageSurveys = (
	createPageSurveyRequest?: BodyType<CreatePageSurveyRequest>,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<PageSurveyResponse>(
		{
			url: `/umbraco/api/v1/umbrella/page-surveys`,
			method: "POST",
			headers: { "Content-Type": "application/json" },
			data: createPageSurveyRequest,
			signal,
		},
		options,
	);
};

export const getPostUmbracoApiV1UmbrellaPageSurveysMutationKey = () =>
	["postUmbracoApiV1UmbrellaPageSurveys"] as const;

export const getPostUmbracoApiV1UmbrellaPageSurveysMutationOptions = <
	TError = ErrorType<void>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postUmbracoApiV1UmbrellaPageSurveys>>,
		TError,
		PostUmbracoApiV1UmbrellaPageSurveysMutationVariables,
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof postUmbracoApiV1UmbrellaPageSurveys>>,
	TError,
	PostUmbracoApiV1UmbrellaPageSurveysMutationVariables,
	TContext
> => {
	const mutationKey = getPostUmbracoApiV1UmbrellaPageSurveysMutationKey();
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof postUmbracoApiV1UmbrellaPageSurveys>>,
		PostUmbracoApiV1UmbrellaPageSurveysMutationVariables
	> = (props) => {
		const { data } = props ?? {};

		return postUmbracoApiV1UmbrellaPageSurveys(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostUmbracoApiV1UmbrellaPageSurveysMutationResult = NonNullable<
	Awaited<ReturnType<typeof postUmbracoApiV1UmbrellaPageSurveys>>
>;
export type PostUmbracoApiV1UmbrellaPageSurveysMutationBody =
	| BodyType<CreatePageSurveyRequest>
	| undefined;
export type PostUmbracoApiV1UmbrellaPageSurveysMutationError = ErrorType<void>;
export type PostUmbracoApiV1UmbrellaPageSurveysMutationVariables = {
	data?: BodyType<CreatePageSurveyRequest>;
};

export const usePostUmbracoApiV1UmbrellaPageSurveys = <
	TError = ErrorType<void>,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof postUmbracoApiV1UmbrellaPageSurveys>>,
			TError,
			PostUmbracoApiV1UmbrellaPageSurveysMutationVariables,
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof postUmbracoApiV1UmbrellaPageSurveys>>,
	TError,
	PostUmbracoApiV1UmbrellaPageSurveysMutationVariables,
	TContext
> => {
	return useMutation(
		getPostUmbracoApiV1UmbrellaPageSurveysMutationOptions(options),
		queryClient,
	);
};
export const getUmbracoApiV1UmbrellaPageSurveys = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<PageSurveyResponse[]>(
		{ url: `/umbraco/api/v1/umbrella/page-surveys`, method: "GET", signal },
		options,
	);
};

export const getGetUmbracoApiV1UmbrellaPageSurveysQueryKey = () => {
	return [`/umbraco/api/v1/umbrella/page-surveys`] as const;
};

export const getGetUmbracoApiV1UmbrellaPageSurveysQueryOptions = <
	TData = Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetUmbracoApiV1UmbrellaPageSurveysQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>
	> = ({ signal }) =>
		getUmbracoApiV1UmbrellaPageSurveys(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUmbracoApiV1UmbrellaPageSurveysQueryResult = NonNullable<
	Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>
>;
export type GetUmbracoApiV1UmbrellaPageSurveysQueryError = ErrorType<unknown>;

export function useGetUmbracoApiV1UmbrellaPageSurveys<
	TData = Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>,
	TError = ErrorType<unknown>,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>,
					TError,
					Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoApiV1UmbrellaPageSurveys<
	TData = Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>,
					TError,
					Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoApiV1UmbrellaPageSurveys<
	TData = Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUmbracoApiV1UmbrellaPageSurveys<
	TData = Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions =
		getGetUmbracoApiV1UmbrellaPageSurveysQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUmbracoApiV1UmbrellaPageSurveysSuspenseQueryOptions = <
	TData = Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseSuspenseQueryOptions<
			Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetUmbracoApiV1UmbrellaPageSurveysQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>
	> = ({ signal }) =>
		getUmbracoApiV1UmbrellaPageSurveys(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
		Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUmbracoApiV1UmbrellaPageSurveysSuspenseQueryResult = NonNullable<
	Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>
>;
export type GetUmbracoApiV1UmbrellaPageSurveysSuspenseQueryError =
	ErrorType<unknown>;

export function useGetUmbracoApiV1UmbrellaPageSurveysSuspense<
	TData = Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>,
	TError = ErrorType<unknown>,
>(
	options: {
		query: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoApiV1UmbrellaPageSurveysSuspense<
	TData = Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoApiV1UmbrellaPageSurveysSuspense<
	TData = Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUmbracoApiV1UmbrellaPageSurveysSuspense<
	TData = Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveys>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions =
		getGetUmbracoApiV1UmbrellaPageSurveysSuspenseQueryOptions(options);

	const query = useSuspenseQuery(
		queryOptions,
		queryClient,
	) as UseSuspenseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return withQueryKey(query, queryOptions.queryKey);
}

export const getUmbracoApiV1UmbrellaPageSurveysId = (
	id: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<PageSurveyResponse>(
		{
			url: `/umbraco/api/v1/umbrella/page-surveys/${id}`,
			method: "GET",
			signal,
		},
		options,
	);
};

export const getGetUmbracoApiV1UmbrellaPageSurveysIdQueryKey = (id: number) => {
	return [`/umbraco/api/v1/umbrella/page-surveys/${id}`] as const;
};

export const getGetUmbracoApiV1UmbrellaPageSurveysIdQueryOptions = <
	TData = Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>,
	TError = ErrorType<void>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetUmbracoApiV1UmbrellaPageSurveysIdQueryKey(id);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>
	> = ({ signal }) =>
		getUmbracoApiV1UmbrellaPageSurveysId(id, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: id !== null && id !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUmbracoApiV1UmbrellaPageSurveysIdQueryResult = NonNullable<
	Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>
>;
export type GetUmbracoApiV1UmbrellaPageSurveysIdQueryError = ErrorType<void>;

export function useGetUmbracoApiV1UmbrellaPageSurveysId<
	TData = Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>,
	TError = ErrorType<void>,
>(
	id: number,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>,
					TError,
					Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoApiV1UmbrellaPageSurveysId<
	TData = Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>,
	TError = ErrorType<void>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>,
					TError,
					Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoApiV1UmbrellaPageSurveysId<
	TData = Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>,
	TError = ErrorType<void>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUmbracoApiV1UmbrellaPageSurveysId<
	TData = Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>,
	TError = ErrorType<void>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetUmbracoApiV1UmbrellaPageSurveysIdQueryOptions(
		id,
		options,
	);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUmbracoApiV1UmbrellaPageSurveysIdSuspenseQueryOptions = <
	TData = Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>,
	TError = ErrorType<void>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetUmbracoApiV1UmbrellaPageSurveysIdQueryKey(id);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>
	> = ({ signal }) =>
		getUmbracoApiV1UmbrellaPageSurveysId(id, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
		Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUmbracoApiV1UmbrellaPageSurveysIdSuspenseQueryResult =
	NonNullable<Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>>;
export type GetUmbracoApiV1UmbrellaPageSurveysIdSuspenseQueryError =
	ErrorType<void>;

export function useGetUmbracoApiV1UmbrellaPageSurveysIdSuspense<
	TData = Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>,
	TError = ErrorType<void>,
>(
	id: number,
	options: {
		query: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoApiV1UmbrellaPageSurveysIdSuspense<
	TData = Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>,
	TError = ErrorType<void>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoApiV1UmbrellaPageSurveysIdSuspense<
	TData = Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>,
	TError = ErrorType<void>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUmbracoApiV1UmbrellaPageSurveysIdSuspense<
	TData = Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>,
	TError = ErrorType<void>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysId>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions =
		getGetUmbracoApiV1UmbrellaPageSurveysIdSuspenseQueryOptions(id, options);

	const query = useSuspenseQuery(
		queryOptions,
		queryClient,
	) as UseSuspenseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return withQueryKey(query, queryOptions.queryKey);
}

export const putUmbracoApiV1UmbrellaPageSurveysId = (
	id: number,
	updatePageSurveyRequest?: BodyType<UpdatePageSurveyRequest>,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<PageSurveyResponse>(
		{
			url: `/umbraco/api/v1/umbrella/page-surveys/${id}`,
			method: "PUT",
			headers: { "Content-Type": "application/json" },
			data: updatePageSurveyRequest,
			signal,
		},
		options,
	);
};

export const getPutUmbracoApiV1UmbrellaPageSurveysIdMutationKey = () =>
	["putUmbracoApiV1UmbrellaPageSurveysId"] as const;

export const getPutUmbracoApiV1UmbrellaPageSurveysIdMutationOptions = <
	TError = ErrorType<void>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof putUmbracoApiV1UmbrellaPageSurveysId>>,
		TError,
		PutUmbracoApiV1UmbrellaPageSurveysIdMutationVariables,
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof putUmbracoApiV1UmbrellaPageSurveysId>>,
	TError,
	PutUmbracoApiV1UmbrellaPageSurveysIdMutationVariables,
	TContext
> => {
	const mutationKey = getPutUmbracoApiV1UmbrellaPageSurveysIdMutationKey();
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof putUmbracoApiV1UmbrellaPageSurveysId>>,
		PutUmbracoApiV1UmbrellaPageSurveysIdMutationVariables
	> = (props) => {
		const { id, data } = props ?? {};

		return putUmbracoApiV1UmbrellaPageSurveysId(id, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PutUmbracoApiV1UmbrellaPageSurveysIdMutationResult = NonNullable<
	Awaited<ReturnType<typeof putUmbracoApiV1UmbrellaPageSurveysId>>
>;
export type PutUmbracoApiV1UmbrellaPageSurveysIdMutationBody =
	| BodyType<UpdatePageSurveyRequest>
	| undefined;
export type PutUmbracoApiV1UmbrellaPageSurveysIdMutationError = ErrorType<void>;
export type PutUmbracoApiV1UmbrellaPageSurveysIdMutationVariables = {
	id: number;
	data?: BodyType<UpdatePageSurveyRequest>;
};

export const usePutUmbracoApiV1UmbrellaPageSurveysId = <
	TError = ErrorType<void>,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof putUmbracoApiV1UmbrellaPageSurveysId>>,
			TError,
			PutUmbracoApiV1UmbrellaPageSurveysIdMutationVariables,
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof putUmbracoApiV1UmbrellaPageSurveysId>>,
	TError,
	PutUmbracoApiV1UmbrellaPageSurveysIdMutationVariables,
	TContext
> => {
	return useMutation(
		getPutUmbracoApiV1UmbrellaPageSurveysIdMutationOptions(options),
		queryClient,
	);
};
export const postUmbracoApiV1UmbrellaPageSurveysRatedQuestions = (
	createPageSurveyRatedQuestionRequest?: BodyType<CreatePageSurveyRatedQuestionRequest>,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<PageSurveyRatedQuestionResponse>(
		{
			url: `/umbraco/api/v1/umbrella/page-surveys/rated-questions`,
			method: "POST",
			headers: { "Content-Type": "application/json" },
			data: createPageSurveyRatedQuestionRequest,
			signal,
		},
		options,
	);
};

export const getPostUmbracoApiV1UmbrellaPageSurveysRatedQuestionsMutationKey =
	() => ["postUmbracoApiV1UmbrellaPageSurveysRatedQuestions"] as const;

export const getPostUmbracoApiV1UmbrellaPageSurveysRatedQuestionsMutationOptions =
	<TError = ErrorType<void>, TContext = unknown>(options?: {
		mutation?: UseMutationOptions<
			Awaited<
				ReturnType<typeof postUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
			>,
			TError,
			PostUmbracoApiV1UmbrellaPageSurveysRatedQuestionsMutationVariables,
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	}): UseMutationOptions<
		Awaited<
			ReturnType<typeof postUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
		>,
		TError,
		PostUmbracoApiV1UmbrellaPageSurveysRatedQuestionsMutationVariables,
		TContext
	> => {
		const mutationKey =
			getPostUmbracoApiV1UmbrellaPageSurveysRatedQuestionsMutationKey();
		const { mutation: mutationOptions, request: requestOptions } = options
			? options.mutation &&
				"mutationKey" in options.mutation &&
				options.mutation.mutationKey
				? options
				: { ...options, mutation: { ...options.mutation, mutationKey } }
			: { mutation: { mutationKey }, request: undefined };

		const mutationFn: MutationFunction<
			Awaited<
				ReturnType<typeof postUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
			>,
			PostUmbracoApiV1UmbrellaPageSurveysRatedQuestionsMutationVariables
		> = (props) => {
			const { data } = props ?? {};

			return postUmbracoApiV1UmbrellaPageSurveysRatedQuestions(
				data,
				requestOptions,
			);
		};

		return { mutationFn, ...mutationOptions };
	};

export type PostUmbracoApiV1UmbrellaPageSurveysRatedQuestionsMutationResult =
	NonNullable<
		Awaited<
			ReturnType<typeof postUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
		>
	>;
export type PostUmbracoApiV1UmbrellaPageSurveysRatedQuestionsMutationBody =
	| BodyType<CreatePageSurveyRatedQuestionRequest>
	| undefined;
export type PostUmbracoApiV1UmbrellaPageSurveysRatedQuestionsMutationError =
	ErrorType<void>;
export type PostUmbracoApiV1UmbrellaPageSurveysRatedQuestionsMutationVariables =
	{ data?: BodyType<CreatePageSurveyRatedQuestionRequest> };

export const usePostUmbracoApiV1UmbrellaPageSurveysRatedQuestions = <
	TError = ErrorType<void>,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<
				ReturnType<typeof postUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
			>,
			TError,
			PostUmbracoApiV1UmbrellaPageSurveysRatedQuestionsMutationVariables,
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof postUmbracoApiV1UmbrellaPageSurveysRatedQuestions>>,
	TError,
	PostUmbracoApiV1UmbrellaPageSurveysRatedQuestionsMutationVariables,
	TContext
> => {
	return useMutation(
		getPostUmbracoApiV1UmbrellaPageSurveysRatedQuestionsMutationOptions(
			options,
		),
		queryClient,
	);
};
export const getUmbracoApiV1UmbrellaPageSurveysRatedQuestions = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<PageSurveyRatedQuestionResponse[]>(
		{
			url: `/umbraco/api/v1/umbrella/page-surveys/rated-questions`,
			method: "GET",
			signal,
		},
		options,
	);
};

export const getGetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsQueryKey =
	() => {
		return [`/umbraco/api/v1/umbrella/page-surveys/rated-questions`] as const;
	};

export const getGetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsQueryOptions = <
	TData = Awaited<
		ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
	>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<
				ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
			>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>>
	> = ({ signal }) =>
		getUmbracoApiV1UmbrellaPageSurveysRatedQuestions(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<
			ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
		>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsQueryResult =
	NonNullable<
		Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>>
	>;
export type GetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsQueryError =
	ErrorType<unknown>;

export function useGetUmbracoApiV1UmbrellaPageSurveysRatedQuestions<
	TData = Awaited<
		ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
	>,
	TError = ErrorType<unknown>,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
				>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<
						ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
					>,
					TError,
					Awaited<
						ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
					>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoApiV1UmbrellaPageSurveysRatedQuestions<
	TData = Awaited<
		ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
	>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
				>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<
						ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
					>,
					TError,
					Awaited<
						ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
					>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoApiV1UmbrellaPageSurveysRatedQuestions<
	TData = Awaited<
		ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
	>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUmbracoApiV1UmbrellaPageSurveysRatedQuestions<
	TData = Awaited<
		ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
	>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions =
		getGetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsSuspenseQueryOptions =
	<
		TData = Awaited<
			ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
		>,
		TError = ErrorType<unknown>,
	>(options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<
					ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	}) => {
		const { query: queryOptions, request: requestOptions } = options ?? {};

		const queryKey =
			queryOptions?.queryKey ??
			getGetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsQueryKey();

		const queryFn: QueryFunction<
			Awaited<
				ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
			>
		> = ({ signal }) =>
			getUmbracoApiV1UmbrellaPageSurveysRatedQuestions(requestOptions, signal);

		return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
			Awaited<
				ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
			>,
			TError,
			TData
		> & { queryKey: DataTag<QueryKey, TData, TError> };
	};

export type GetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsSuspenseQueryResult =
	NonNullable<
		Awaited<ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>>
	>;
export type GetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsSuspenseQueryError =
	ErrorType<unknown>;

export function useGetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsSuspense<
	TData = Awaited<
		ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
	>,
	TError = ErrorType<unknown>,
>(
	options: {
		query: Partial<
			UseSuspenseQueryOptions<
				Awaited<
					ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsSuspense<
	TData = Awaited<
		ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
	>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<
					ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsSuspense<
	TData = Awaited<
		ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
	>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<
					ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsSuspense<
	TData = Awaited<
		ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
	>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<
					ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestions>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions =
		getGetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsSuspenseQueryOptions(
			options,
		);

	const query = useSuspenseQuery(
		queryOptions,
		queryClient,
	) as UseSuspenseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return withQueryKey(query, queryOptions.queryKey);
}

export const getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId = (
	id: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<PageSurveyRatedQuestionResponse>(
		{
			url: `/umbraco/api/v1/umbrella/page-surveys/rated-questions/${id}`,
			method: "GET",
			signal,
		},
		options,
	);
};

export const getGetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdQueryKey = (
	id: number,
) => {
	return [
		`/umbraco/api/v1/umbrella/page-surveys/rated-questions/${id}`,
	] as const;
};

export const getGetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdQueryOptions =
	<
		TData = Awaited<
			ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
		>,
		TError = ErrorType<void>,
	>(
		id: number,
		options?: {
			query?: Partial<
				UseQueryOptions<
					Awaited<
						ReturnType<
							typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId
						>
					>,
					TError,
					TData
				>
			>;
			request?: SecondParameter<typeof customInstance>;
		},
	) => {
		const { query: queryOptions, request: requestOptions } = options ?? {};

		const queryKey =
			queryOptions?.queryKey ??
			getGetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdQueryKey(id);

		const queryFn: QueryFunction<
			Awaited<
				ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
			>
		> = ({ signal }) =>
			getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId(
				id,
				requestOptions,
				signal,
			);

		return {
			queryKey,
			queryFn,
			enabled: id !== null && id !== undefined,
			...queryOptions,
		} as UseQueryOptions<
			Awaited<
				ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
			>,
			TError,
			TData
		> & { queryKey: DataTag<QueryKey, TData, TError> };
	};

export type GetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdQueryResult =
	NonNullable<
		Awaited<
			ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
		>
	>;
export type GetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdQueryError =
	ErrorType<void>;

export function useGetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId<
	TData = Awaited<
		ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
	>,
	TError = ErrorType<void>,
>(
	id: number,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
				>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId
						>
					>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId<
	TData = Awaited<
		ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
	>,
	TError = ErrorType<void>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
				>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId
						>
					>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId<
	TData = Awaited<
		ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
	>,
	TError = ErrorType<void>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId<
	TData = Awaited<
		ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
	>,
	TError = ErrorType<void>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions =
		getGetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdQueryOptions(
			id,
			options,
		);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdSuspenseQueryOptions =
	<
		TData = Awaited<
			ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
		>,
		TError = ErrorType<void>,
	>(
		id: number,
		options?: {
			query?: Partial<
				UseSuspenseQueryOptions<
					Awaited<
						ReturnType<
							typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId
						>
					>,
					TError,
					TData
				>
			>;
			request?: SecondParameter<typeof customInstance>;
		},
	) => {
		const { query: queryOptions, request: requestOptions } = options ?? {};

		const queryKey =
			queryOptions?.queryKey ??
			getGetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdQueryKey(id);

		const queryFn: QueryFunction<
			Awaited<
				ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
			>
		> = ({ signal }) =>
			getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId(
				id,
				requestOptions,
				signal,
			);

		return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
			Awaited<
				ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
			>,
			TError,
			TData
		> & { queryKey: DataTag<QueryKey, TData, TError> };
	};

export type GetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdSuspenseQueryResult =
	NonNullable<
		Awaited<
			ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
		>
	>;
export type GetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdSuspenseQueryError =
	ErrorType<void>;

export function useGetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdSuspense<
	TData = Awaited<
		ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
	>,
	TError = ErrorType<void>,
>(
	id: number,
	options: {
		query: Partial<
			UseSuspenseQueryOptions<
				Awaited<
					ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdSuspense<
	TData = Awaited<
		ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
	>,
	TError = ErrorType<void>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<
					ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdSuspense<
	TData = Awaited<
		ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
	>,
	TError = ErrorType<void>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<
					ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdSuspense<
	TData = Awaited<
		ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
	>,
	TError = ErrorType<void>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<
					ReturnType<typeof getUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions =
		getGetUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdSuspenseQueryOptions(
			id,
			options,
		);

	const query = useSuspenseQuery(
		queryOptions,
		queryClient,
	) as UseSuspenseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return withQueryKey(query, queryOptions.queryKey);
}

export const putUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId = (
	id: number,
	updatePageSurveyRatedQuestionRequest?: BodyType<UpdatePageSurveyRatedQuestionRequest>,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<PageSurveyRatedQuestionResponse>(
		{
			url: `/umbraco/api/v1/umbrella/page-surveys/rated-questions/${id}`,
			method: "PUT",
			headers: { "Content-Type": "application/json" },
			data: updatePageSurveyRatedQuestionRequest,
			signal,
		},
		options,
	);
};

export const getPutUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdMutationKey =
	() => ["putUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId"] as const;

export const getPutUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdMutationOptions =
	<TError = ErrorType<void>, TContext = unknown>(options?: {
		mutation?: UseMutationOptions<
			Awaited<
				ReturnType<typeof putUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
			>,
			TError,
			PutUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdMutationVariables,
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	}): UseMutationOptions<
		Awaited<
			ReturnType<typeof putUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
		>,
		TError,
		PutUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdMutationVariables,
		TContext
	> => {
		const mutationKey =
			getPutUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdMutationKey();
		const { mutation: mutationOptions, request: requestOptions } = options
			? options.mutation &&
				"mutationKey" in options.mutation &&
				options.mutation.mutationKey
				? options
				: { ...options, mutation: { ...options.mutation, mutationKey } }
			: { mutation: { mutationKey }, request: undefined };

		const mutationFn: MutationFunction<
			Awaited<
				ReturnType<typeof putUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
			>,
			PutUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdMutationVariables
		> = (props) => {
			const { id, data } = props ?? {};

			return putUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId(
				id,
				data,
				requestOptions,
			);
		};

		return { mutationFn, ...mutationOptions };
	};

export type PutUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdMutationResult =
	NonNullable<
		Awaited<
			ReturnType<typeof putUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
		>
	>;
export type PutUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdMutationBody =
	| BodyType<UpdatePageSurveyRatedQuestionRequest>
	| undefined;
export type PutUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdMutationError =
	ErrorType<void>;
export type PutUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdMutationVariables =
	{ id: number; data?: BodyType<UpdatePageSurveyRatedQuestionRequest> };

export const usePutUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId = <
	TError = ErrorType<void>,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<
				ReturnType<typeof putUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
			>,
			TError,
			PutUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdMutationVariables,
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<
		ReturnType<typeof putUmbracoApiV1UmbrellaPageSurveysRatedQuestionsId>
	>,
	TError,
	PutUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdMutationVariables,
	TContext
> => {
	return useMutation(
		getPutUmbracoApiV1UmbrellaPageSurveysRatedQuestionsIdMutationOptions(
			options,
		),
		queryClient,
	);
};
